import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './scss/custom.scss'
import i18n from "./i18n/index";

import {
  ButtonPlugin,
  DropdownPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  InputGroupPlugin,
  LayoutPlugin,
  PopoverPlugin,
  TabsPlugin,
  EmbedPlugin
} from 'bootstrap-vue'

import vOutsideEvents from 'vue-outside-events'

(function () {
  var throttle = function (type, name, obj) {
    obj = obj || window;
    var running = false;
    var func = function () {
      if (running) {
        return;
      }
      running = true;
      requestAnimationFrame(function () {
        obj.dispatchEvent(new CustomEvent(name));
        running = false;
      });
    };
    obj.addEventListener(type, func);
  };

  /* init - you can init any event */
  throttle("resize", "optimizedResize");
})();

Vue.use(vOutsideEvents);

Vue.config.keyCodes = {
  arrows: [37, 38, 39, 40]
};

Vue.config.productionTip = false;
Vue.use(TabsPlugin);
Vue.use(InputGroupPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(LayoutPlugin);
Vue.use(PopoverPlugin);
Vue.use(ButtonPlugin);
Vue.use(DropdownPlugin);
Vue.use(EmbedPlugin);

new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#calculator');
